import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import PrivateLayout from './privateLayout';

import { useAuth } from '../contexts/authContext';
import { hasAccess } from '../helpers/access';

const PrivateRoute = ({ role }) => {
  const { authenticated, currentUserProfile, workspaceRequired } = useAuth();
  const location = useLocation();

  // if (authenticated && !currentUserProfile) {
  //   return <Navigate to={'/user/profile'} />;
  // }

  if (!authenticated) {
    return <Navigate to={'/signin'} />;
  }

  if (role) {
    if (!hasAccess(currentUserProfile, role)) {
      return <Navigate to={'/'} />;
    }
  }

  if (workspaceRequired && location.pathname !== '/workspace-settings') {
    return <Navigate to={'/workspace-settings'} replace />;
  }

  return (
    <PrivateLayout>
      <Outlet />
    </PrivateLayout>
  );
};

export default PrivateRoute;
